var React = require( 'react' );
var createReactClass = require('create-react-class');
var Callout = require('../../../components/callout.jsx');

var Contact = createReactClass({

    componentWillUnmount: function(){
        this.props.clearContactError();
    },

    handleSubmit: function(event){
        event.preventDefault();

        var email = this.refs.email.value;
        var subject = this.refs.subject.value;
        var message = this.refs.message.value;
        this.props.sendContact(email, subject, message);
    },

    render: function(){
        return (
        	<div id="contact-us" className="contact-us" data-toggler="is-active">
                <div className="row">
                    <div className="column">
                        <div className="contact-us-hd" data-toggle="contact-us">
                            <h2>Contact Us</h2>
                            <p>Questions, suggestions or comments about MyGiHealth? <strong>We'd love to hear from you!</strong></p>
                        </div>

                        <form className="contact-us-bd" noValidate>
                            {Object.keys(this.props.error).length !== 0 &&
            		            <Callout type="alert" message={this.props.error} handleClose={this.props.clearContactError} />
            		        }
                            <div className="input-field-wrapper">
                                <div className="input-field">
                                    <label htmlFor="email">Email</label>
                                    <input id="email" name="email" ref="email" type="email" placeholder="Email" />
                                </div>
                                <div className="input-field">
                                    <label htmlFor="subject" className="text-left">Subject</label>
                                    <input id="subject" name="subject" ref="subject" type="text" placeholder="Subject" />
                                </div>
                                <label htmlFor="message">Message</label>
                                <textarea id="message" name="message" ref="message" placeholder="Message" />
                            </div>

                            <button className="button" type="submit" onClick={this.handleSubmit}>Send Your Message</button>
                        </form>
                    </div>
                </div>
        	</div>
        );
    }
});

module.exports = Contact;



// WEBPACK FOOTER //
// ./src/common/routes/faqs/components/layout/contact.jsx